<!-- Account Already Registered Screen -->
<div *ngIf="showAccountAlreadyRegistered" class="account-registered-wrapper">
  <div class="account-registered-content">
    <h2 class="account-registered-title">Register Account</h2>

    <div class="account-registered-icon">
      <i class="fa-solid fa-user"></i>
      <i class="fa-solid fa-exclamation exclamation-icon"></i>
    </div>

    <p class="account-registered-message">
      It looks like your account has already been registered in the Resident
      Portal. Please
      <a (click)="btnBackToLogin()" class="signin-link">sign in</a>
      with your credentials.
    </p>

    <div class="account-registered-links">
      <div class="link-row">
        <span>Forgot your password?</span>
        <a (click)="btnForgotPassword()" class="action-link">Reset now</a>
      </div>
      <div class="link-row">
        <span>
          Forgot your username or need to validate your email address?
        </span>
        <a (click)="btnForgotUsername()" class="action-link">Retrieve now</a>
      </div>
    </div>
  </div>
</div>

<dx-validation-group #validatorSignup *ngIf="!showAccountAlreadyRegistered">
  <dx-responsive-box>
    <dxi-row></dxi-row>
    <dxi-row></dxi-row>
    <dxi-row></dxi-row>
    <dxi-row></dxi-row>
    <dxi-row></dxi-row>
    <dxi-row></dxi-row>
    <dxi-row></dxi-row>
    <dxi-row></dxi-row>
    <dxi-row></dxi-row>
    <dxi-row></dxi-row>
    <dxi-row></dxi-row>

    <dxi-col></dxi-col>
    <dxi-col></dxi-col>

    <dxi-item>
      <dxi-location screen="md lg" [row]="0" [col]="0"></dxi-location>
      <dxi-location
        screen="xs sm"
        [row]="0"
        [col]="0"
        [colspan]="2"
      ></dxi-location>
      <div class="user-auth-container-input-container">
        <div class="user-auth-container-input-wrapper">
          <dx-text-box
            placeholder="Account#"
            [(value)]="userInfo.customerID"
            class="text-input cc-text-required"
          >
            <dx-validator>
              <dxi-validation-rule
                type="required"
                message="Account number is required"
              ></dxi-validation-rule>
            </dx-validator>
            <dxi-button
              name="help"
              location="after"
              [options]="helpButton"
            ></dxi-button>
          </dx-text-box>
        </div>
      </div>
    </dxi-item>

    <dxi-item>
      <dxi-location screen="md lg" [row]="0" [col]="1"></dxi-location>
      <dxi-location
        screen="xs sm"
        [row]="1"
        [col]="0"
        [colspan]="2"
      ></dxi-location>
      <div class="user-auth-container-input-container">
        <div class="user-auth-container-input-wrapper">
          <dx-text-box
            placeholder="Check Digit"
            class="text-input cc-text-required"
            [(value)]="userInfo.checkDigit"
          >
            <dx-validator>
              <dxi-validation-rule
                type="required"
                message="Check digit is required"
              ></dxi-validation-rule>
              <dxi-validation-rule
                type="numeric"
                message="Invalid Check digit"
              ></dxi-validation-rule>
            </dx-validator>
            <dxi-button
              name="help"
              location="after"
              [options]="helpButton"
            ></dxi-button>
          </dx-text-box>
        </div>
      </div>
    </dxi-item>

    <dxi-item>
      <dxi-location screen="md lg" [row]="1" [col]="0"></dxi-location>
      <dxi-location
        screen="xs sm"
        [row]="2"
        [col]="0"
        [colspan]="2"
      ></dxi-location>
      <div class="user-auth-container-input-container">
        <div class="user-auth-container-input-wrapper">
          <dx-text-box
            ccPreventCopyPaste
            placeholder="Email"
            class="text-input cc-text-required"
            [(value)]="userInfo.email"
          >
            <dx-validator #emailValidator>
              <dxi-validation-rule
                type="required"
                message="Email is required"
              ></dxi-validation-rule>
              <dxi-validation-rule
                type="pattern"
                [pattern]="emailPattern"
                message="Invalid email address"
              ></dxi-validation-rule>
            </dx-validator>
          </dx-text-box>
        </div>
      </div>
    </dxi-item>

    <dxi-item>
      <dxi-location screen="md lg" [row]="1" [col]="1"></dxi-location>
      <dxi-location
        screen="xs sm"
        [row]="3"
        [col]="0"
        [colspan]="2"
      ></dxi-location>
      <div class="user-auth-container-input-container">
        <div class="user-auth-container-input-wrapper">
          <dx-text-box
            ccPreventCopyPaste
            placeholder="Confirm Email"
            class="text-input cc-text-required"
            [(value)]="userInfo.confirmEmail"
          >
            <dx-validator #confirmEmailValidator>
              <dxi-validation-rule
                type="required"
                message="Confirm Email is required"
              ></dxi-validation-rule>
              <dxi-validation-rule
                type="pattern"
                [pattern]="emailPattern"
                message="Invalid Confirm Email address"
              ></dxi-validation-rule>
              <dxi-validation-rule
                type="compare"
                [comparisonTarget]="emailComparison"
                comparisonType="==="
                message="Email and Confirm Email do not match"
              ></dxi-validation-rule>
            </dx-validator>
          </dx-text-box>
        </div>
      </div>
    </dxi-item>

    <dxi-item>
      <dxi-location
        screen="md lg"
        [row]="2"
        [col]="0"
        [colspan]="2"
      ></dxi-location>
      <dxi-location
        screen="xs sm"
        [row]="4"
        [col]="0"
        [colspan]="2"
      ></dxi-location>
      <div class="user-auth-container-input-container">
        <div class="user-auth-container-input-wrapper">
          <div>
            Your email address will be your user ID for the Owner / Resident
            Portal
          </div>
        </div>
      </div>
    </dxi-item>

    <dxi-item>
      <dxi-location screen="md lg" [row]="3" [col]="0"></dxi-location>
      <dxi-location
        screen="xs sm"
        [row]="5"
        [col]="0"
        [colspan]="2"
      ></dxi-location>
      <div class="user-auth-container-input-container">
        <div class="user-auth-container-input-wrapper">
          <dx-text-box
            ccPreventCopyPaste
            placeholder="Password"
            class="text-input cc-text-required"
            [(value)]="userInfo.password"
            [(mode)]="passwordMode"
            [inputAttr]="{ autocomplete: 'new-password' }"
            [maxLength]="30"
            (onKeyUp)="runPasswordValidation($event)"
          >
            <dxi-button
              *ngIf="passwordMode === 'password'"
              name="password"
              location="after"
              [options]="passwordShowButton"
            ></dxi-button>
            <dxi-button
              *ngIf="passwordMode !== 'password'"
              name="password"
              location="after"
              [options]="passwordHideButton"
            ></dxi-button>
            <dx-validator>
              <dxi-validation-rule
                type="required"
                message="Password is required"
              ></dxi-validation-rule>
            </dx-validator>
          </dx-text-box>
        </div>
      </div>
    </dxi-item>

    <dxi-item>
      <dxi-location screen="md lg" [row]="3" [col]="1"></dxi-location>
      <dxi-location
        screen="xs sm"
        [row]="6"
        [col]="0"
        [colspan]="2"
      ></dxi-location>
      <div class="user-auth-container-input-container">
        <div class="user-auth-container-input-wrapper">
          <dx-text-box
            ccPreventCopyPaste
            placeholder="Confirm Password"
            ngClass="text-input cc-text-required"
            [(mode)]="passwordMode"
            [inputAttr]="{ autocomplete: 'new-password' }"
            [maxLength]="30"
          >
            <dxi-button
              *ngIf="passwordMode === 'password'"
              name="cpassword"
              location="after"
              [options]="passwordShowButton"
            ></dxi-button>
            <dxi-button
              *ngIf="passwordMode !== 'password'"
              name="cpassword"
              location="after"
              [options]="passwordHideButton"
            ></dxi-button>
            <dx-validator #confirmPasswordValidator>
              <dxi-validation-rule
                type="required"
                message="Confirm Password is required"
              ></dxi-validation-rule>
              <dxi-validation-rule
                type="compare"
                [comparisonTarget]="passwordComparison"
                comparisonType="==="
                message="Password and Confirm Password do not match"
              ></dxi-validation-rule>
            </dx-validator>
          </dx-text-box>
        </div>
      </div>
    </dxi-item>

    <dxi-item>
      <dxi-location
        screen="md lg"
        [row]="4"
        [col]="0"
        [colspan]="2"
      ></dxi-location>
      <dxi-location
        screen="xs sm"
        [row]="7"
        [col]="0"
        [colspan]="2"
      ></dxi-location>
      <div class="user-auth-container-input-container">
        <div class="user-auth-container-input-wrapper">
          <ul class="password-rules">
            <li *ngFor="let rule of passwordRules">
              <i
                [ngClass]="[
                  iconCircleCheck,
                  rule.isValid ? 'cc-icon-green' : 'cc-icon-mintgreen'
                ]"
              ></i>
              <span [ngClass]="{ 'cc-text-required': !rule.isValid }">
                {{ rule.label }}
              </span>
            </li>
          </ul>
        </div>
      </div>
    </dxi-item>

    <dxi-item>
      <dxi-location
        screen="md lg"
        [row]="5"
        [col]="0"
        [colspan]="2"
      ></dxi-location>
      <dxi-location
        screen="xs sm"
        [row]="8"
        [col]="0"
        [colspan]="2"
      ></dxi-location>
      <div class="user-auth-container-input-container">
        <div class="user-auth-container-input-wrapper">
          <dx-progress-bar
            [min]="0"
            [max]="5"
            #passStrengthSuccess
            [statusFormat]="getPasswordStrengthText"
          ></dx-progress-bar>
        </div>
      </div>
    </dxi-item>

    <dxi-item>
      <dxi-location
        screen="md lg"
        [row]="6"
        [col]="0"
        [colspan]="2"
      ></dxi-location>
      <dxi-location
        screen="xs sm"
        [row]="9"
        [col]="0"
        [colspan]="2"
      ></dxi-location>
      <div
        *dxTemplate
        class="user-auth-container-input-wrapper align-items-center"
      >
        <re-captcha
          #reCaptcha
          [siteKey]="recaptchaSiteKey"
          errorMode="handled"
          (resolved)="onRecaptchaResolved($event)"
          (errored)="onRecaptchaErrored()"
        ></re-captcha>
        <p *ngIf="recaptchaErrorMessage" class="recaptcha-error-message">
          {{ recaptchaErrorMessage }}
        </p>
      </div>
    </dxi-item>

    <dxi-item>
      <dxi-location screen="md lg" [row]="7" [col]="0"></dxi-location>
      <dxi-location screen="xs sm" [row]="10" [col]="0"></dxi-location>
      <div *dxTemplate class="user-auth-container-btn-wrapper align-items-end">
        <div class="register-button-content">
          <dx-button
            #btnRegister
            text="Continue"
            class="register-button"
            type="default"
            [disabled]="!recaptchaToken"
            [width]="isSmallScreen ? 110 : 130"
            [height]="30"
            (onClick)="btnNextClick()"
            icon="fas fa-user-plus"
          ></dx-button>
        </div>
      </div>
    </dxi-item>

    <dxi-item *ngIf="showGoogleAuth">
      <dxi-location
        screen="md lg"
        [row]="8"
        [col]="0"
        [colspan]="2"
      ></dxi-location>
      <dxi-location
        screen="xs sm"
        [row]="11"
        [col]="0"
        [colspan]="2"
      ></dxi-location>
      <div class="user-auth-container-input-container">
        <div class="user-auth-container-input-wrapper">
          <div class="login-divider-with-image">
            <img
              src="assets/images/divider-left.svg"
              alt="divider line"
              class="divider-line"
            />
            <span>OR</span>
            <img
              src="assets/images/divider-right.svg"
              alt="divider line"
              class="divider-line"
            />
          </div>
        </div>
      </div>
    </dxi-item>

    <dxi-item *ngIf="showGoogleAuth">
      <dxi-location
        screen="md lg"
        [row]="9"
        [col]="0"
        [colspan]="2"
      ></dxi-location>
      <dxi-location
        screen="xs sm"
        [row]="12"
        [col]="0"
        [colspan]="2"
      ></dxi-location>
      <div class="user-auth-container-input-container">
        <div class="user-auth-container-input-wrapper">
          <div class="google-signin-container">
            <dx-button
              class="google-signin-button"
              type="default"
              (onClick)="btnGoogleSignupClick()"
            >
              <div class="google-button-content">
                <img
                  src="assets/images/google-logo.svg"
                  alt="Google logo"
                  class="google-logo"
                />
                <span>Sign up with Google</span>
              </div>
            </dx-button>
          </div>
        </div>
      </div>
    </dxi-item>

    <dxi-item>
      <dxi-location screen="md lg" [row]="7" [col]="1"></dxi-location>
      <dxi-location screen="xs sm" [row]="10" [col]="1"></dxi-location>
      <div
        *dxTemplate
        class="user-auth-container-btn-wrapper align-items-start"
      >
        <dx-button
          #btnLogin
          text="Back to Login"
          [icon]="backToLoginIcon"
          class="back-to-login-button"
          type="default"
          [width]="isSmallScreen ? 120 : 130"
          [height]="30"
          (onClick)="btnBackToLogin()"
        ></dx-button>
      </div>
    </dxi-item>
  </dx-responsive-box>
</dx-validation-group>

<dx-popup
  minWidth="300px"
  minHeight="254px"
  width="50%"
  height="auto"
  [showTitle]="true"
  title="Information You Need"
  [dragEnabled]="true"
  [hideOnOutsideClick]="true"
  [(visible)]="isHelpShow"
>
  <div *dxTemplate="let data of 'content'">
    <div dx-scroll-view="{ height: '100%' }" class="container">
      <div class="row help-text-container">
        Your Account Number, Community ID and Check Digit can be found on your
        statement as highlighted below.
      </div>
      <div class="row">
        <img [src]="helpImage" class="help-pop-up-image" />
      </div>
    </div>
  </div>
</dx-popup>

<dx-load-panel
  #loadPanelLogin
  shadingColor="rgba(0,0,0,0.4)"
  [position]="{ of: '#loginContainer' }"
  [(visible)]="loadingVisible"
  [showIndicator]="true"
  [showPane]="true"
  [shading]="true"
  [hideOnOutsideClick]="false"
></dx-load-panel>

<cc-message-box #messageBox></cc-message-box>
